import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import {CreativeTemplateTrackChangesState} from './creativeTemplateTrackChanges.types';

export const creativeTemplateTrackChangesInitialState: CreativeTemplateTrackChangesState = {
  isUnsavedChangesMade: false,
  isInSavingProcess: false,
  isTemplateChangedByCollaborator: false,
};

const creativeTemplateTrackChangesReducer = createSlice({
  name: `${BreadcrumbName.CreativeTemplatePage}/trackChanges`,
  initialState: creativeTemplateTrackChangesInitialState,
  reducers: {
    resetTrackChangesState: () => creativeTemplateTrackChangesInitialState,

    setIsUnsavedChangesMade: (state, action: PayloadAction<boolean>) => {
      state.isUnsavedChangesMade = action.payload;
    },

    setIsInSavingProcess: (state, action: PayloadAction<boolean>) => {
      state.isInSavingProcess = action.payload;
    },

    setIsTemplateChangedByCollaborator: (state, action: PayloadAction<boolean>) => {
      state.isTemplateChangedByCollaborator = action.payload;
    },
  },
});

export const {
  resetTrackChangesState,
  setIsUnsavedChangesMade,
  setIsInSavingProcess,
  setIsTemplateChangedByCollaborator,
} = creativeTemplateTrackChangesReducer.actions;

export default creativeTemplateTrackChangesReducer.reducer;
